import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleUpLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M16.98 13.125c.673 1.167-.169 2.625-1.516 2.625H8.536c-1.347 0-2.19-1.458-1.516-2.625l3.465-6c.673-1.167 2.357-1.167 3.03 0zm-1.516 1.125a.25.25 0 0 0 .217-.375l-3.464-6a.25.25 0 0 0-.433 0l-3.465 6a.25.25 0 0 0 .217.375z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleUpLine)
export default ForwardRef
